<script>

    import './$styles/bulma.scss'
    import './$styles/global.scss'

    import { toast } from 'bulma-toast'
    import Router, { replace } from 'svelte-spa-router'

    import { SessionStore, UserStore, LatLngStore } from './stores'
    import { routes } from './routes'

    import LocalstoreService from './localstore'
    import UsersService from './$services/users.service'

    function failed(event) {

        if(event.detail.route === '/login')
            return replace('#/shipments')

        if(event.detail.route != '/login')
            return replace('#/login')
    }

    async function loaded(event) {

        const skips = [
            '/quotation',
            '/tracking',
            '/tracking/:shipmentId'
        ]

        if(skips.indexOf(event.detail.route) >= 0)
            return

        if(event.detail.route != '/login' && event.detail.route != '/signup') {
            try {
                
                const resp = await UsersService.verifyToken($SessionStore.token)
    
                if(resp.data.user._id != $UserStore._id)
                    return logout('Acceso incorrecto')

            } catch(error) {
                logout('Se requiere iniciar sesión')
            }
        }
    }

    function logout(message) {
        LocalstoreService.deleteItem('user')
        LocalstoreService.deleteItem('session')
        UserStore.set(null)
        toast({message, type: 'is-danger'})
        replace('#/login')
    }

    navigator.geolocation.watchPosition(position => {
        LatLngStore.set({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        })
    })

</script>

<Router {routes}
    on:routeLoaded={loaded}
    on:conditionsFailed={failed}
/>